<template>
  <div class="container">
    <Breadcrumb class="breadcrumb">
      <BreadcrumbItem to="/">
        <Icon type="ios-home" class="home" />首页
      </BreadcrumbItem>
      <Breadcrumb-item class="breadcrumb-item">学习中心</Breadcrumb-item>
      <Breadcrumb-item class="breadcrumb-item-last">{{courseName}}</Breadcrumb-item>
      <Breadcrumb-item class="breadcrumb-item-last">视频收藏</Breadcrumb-item>
    </Breadcrumb>

    <div class="practice-header">
      <div class="practice-title">
        <h1>{{currentVideoInfo.pptName}}</h1>
      </div>
    </div>
    <div class="video-container">
      <div class="clearfix video-wrap">
        <div class="video-nodata" v-show="favVideoList.length==0">
          <img src="../../assets/images/nodata-02.png" alt="no-data" />
          <p>还没有收藏的视频</p>
        </div>
        <div class="fl video-play" v-if="favVideoList.length>0">
          <video-player :width="770" :height="468"></video-player>
        </div>
        <div class="fr video-catalog" v-if="favVideoList.length>0">
          <h3 class="video-catalog-header">已收藏的视频({{favVideoList.length}})</h3>
          <div class="video-catalog-wrap">
            <happy-scroll color="rgba(42,85,218,0.8)" resize hide-horizontal>
              <ul class="video-fav-list">
                <li v-for="(item,index) in favVideoList" :key="index" :class="{active:pptId==item.pptId}">
                  <div class="title-img">
                    <router-link :to="{name:'FavVideo',query:{umcid:umcId,pptid:item.pptId}}">
                      <img :src="item.picFileName2" :alt="item.pptName" />
                    </router-link>
                  </div>
                  <div class="right-side">
                    <div class="video-title">
                      <router-link :to="{name:'FavVideo',query:{umcid:umcId,pptid:item.pptId}}">{{item.pptName}}</router-link>
                    </div>
                    <div class="video-attr">视频：已看 {{item.playTimes}} 次</div>
                  </div>
                </li>
              </ul>
            </happy-scroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "../../components/common/VideoPlayer";
import { siteMixin } from "../../utils/mixin";
import { study } from "../../request";
import { HappyScroll } from "vue-happy-scroll";
import "vue-happy-scroll/docs/happy-scroll.css";
export default {
  mixins: [siteMixin],
  data() {
    return {
      favVideoList: [],
      currentVideoInfo: {},
      courseName: ""
    };
  },
  watch: {
    $route(to, from) {
      if (to.query.pptid != from.query.pptid) {
        this.setPptId(to.query.pptid);
        this.changeVideo();
      }
    }
  },
  mounted() {
    this.setMetaData("视频收藏");
    if (!this.initParams()) return;
    this.getCourseName();
    this.getFavVideoList();
  },
  methods: {
    initParams() {
      let umcId = this.$route.params.id;
      if (umcId) {
        this.setUmcId(umcId);
        return true;
      } else {
        this.$Message.error("参数错误");
        return false;
      }
    },
    getFavVideoList() {
      study.getFavVideo(this.umcId).then(res => {
        console.log(res);
        if (res.status === 1) {
          this.favVideoList = res.data;
          if (this.favVideoList.length > 0) {
            this.setPptId(this.favVideoList[0].pptId);
          }
          this.changeVideo();
        }
      });
    },
    getCourseName() {
      study.getUmcInfo(this.umcId).then(res => {
        if (res.status === 1) {
          this.courseName = res.data.courseName;
        }
      });
    },
    changeVideo() {
      let vList = this.favVideoList.filter(m => m.pptId == this.pptId);
      if (vList.length > 0) {
        this.currentVideoInfo = vList[0];
        this.setVideoId(this.currentVideoInfo.bVideoId);
      }
    }
  },
  components: {
    VideoPlayer,
    HappyScroll
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/exercise.less";
.breadcrumb {
  padding: 1rem 0;
  .home {
    vertical-align: -0.05em;
    margin-right: 0.2rem;
  }
}
.video-wrap {
  border: 2px solid #e6e6e6;
  padding: 30px;
  margin: 2.4rem auto;
  background-color: #fff;
  .video-play {
    width: 770px;
    height: 468px;
    overflow: hidden;
  }
}
.video-nodata {
  padding: 35px;
  img {
    margin: 0 auto;
  }
  p {
    margin-top: 16px;
    text-align: center;
    font-size: 1.8rem;
    text-indent: 1em;
  }
}
.am-margin-top-lg {
  margin-top: 2.4rem;
}
.video-catalog-header {
  color: #666;
  font-size: 1.6rem;
  padding-bottom: 10px;
}

.video-catalog-wrap {
  width: 350px;
  height: 435px;
}
.video-fav-list {
  width: 350px;
  padding: 0 10px 20px 10px;
}
.video-fav-list li.active {
  background: #efefef;
}
.video-fav-list li {
  font-size: 1.4rem;
  height: 75px;
  /* border-bottom: 1px solid #494949; */
  padding: 10px;
  border-radius: 3px;
  overflow: hidden;
}
.video-fav-list li .title-img {
  width: 96px;
  height: 54px;
  overflow: hidden;
  float: left;
}
.video-fav-list li .title-img img {
  width: 100%;
  height: auto;
}
.video-fav-list li .right-side {
  width: 196px;
  padding-left: 10px;
  height: 54px;
  float: left;
  overflow: hidden;
}
.video-fav-list li.active .right-side .video-title {
  color: #666;
}
.video-fav-list li .right-side .video-title {
  height: 28px;
  line-height: 25px;
  overflow: hidden;
  color: #c8c8c8;
}
.video-fav-list li .right-side .video-attr {
  line-height: 24px;
  height: 24px;
  overflow: hidden;
  color: #969696;
}
</style>

